export default __webpack_public_path__ + "static/media/logo_McKinsey-Company_white.f6568807.png";